const _ = require('lodash');
const {
  getExceptionDays,
  getWorkDays,
  addSubtractWorkDaysToDate,
  daysBetween
} = require('./p6calendar');
import * as permissions from './permissions';
var moment = require("moment");
let project;
let projectMembers;
let projShortName;

let MAX_NUM_FILTER_CODES = 4;

//1d arrays for parent and sub activity codes
let activityTasks;
let taskArray;
let updatePeriodType;
let projectArray;
let projectWbsArray; //used for re-import wbs code
let calendarArray; //used for day hour count
let activityCodesArray; //need to initialize size inside of the callback function
let activitySubCodesArray; //need to initialize size inside of the callback function
let projectWbsAccordion;
let allUpdateData;

let reminderDate;
let userSubCodeSelection;
let userTotalFloatSelections;

//~~~~~~~~~~~~~~~~~~~~~~~~~~~END - GOING TO SERVER~~~~~~~~~~~~~~~~//
// Selected

let possibleLookaheadValues = [30, 45, 60, 90];
let totalFloatPermissionUserIdsMap = {};
let selectedFilteringCodes = [];
let filterCodeOptions = [];
let activitiesByUser = {};
let xerLoaded = false;


// go through, get immediate children
export function resetAllData():any {
  project=undefined;
  projectMembers=undefined;
  projShortName=undefined;
  activityTasks=undefined;
  taskArray=undefined;
  updatePeriodType=undefined;
  projectArray=undefined;
  projectWbsArray=undefined;
  calendarArray=undefined;
  activityCodesArray=undefined;
  activitySubCodesArray=undefined;
  projectWbsAccordion=undefined;
  allUpdateData=undefined;
  reminderDate=undefined;
  userSubCodeSelection=undefined;
  userTotalFloatSelections=undefined;
  possibleLookaheadValues = [30, 45, 60, 90];
  totalFloatPermissionUserIdsMap = {};
  selectedFilteringCodes = [];
  filterCodeOptions = [];
  activitiesByUser = {};
  xerLoaded = false;
}
//
export function getAllUpdateData():any {
  return allUpdateData;
}
export function getWbsChildren(wbsArray):any {
  let wbsChildren = {};
  wbsArray.forEach((wbs) => {
    wbsChildren[wbs.wbs_id] = wbsArray.filter((innerWbs) => {
      return innerWbs.parent_wbs_id === wbs.wbs_id;
    }).map((innerWbs) => innerWbs.wbs_id);
  });
  return wbsChildren;
}

export function getWbsParents(wbsArray):any {
  let wbsParents = {};
  let wbsFullParents = {};
  wbsArray.forEach((wbs) => {
    wbsParents[wbs.wbs_id] = wbs.parent_wbs_id;
  });
  wbsArray.forEach((wbs) => {
    wbsFullParents[wbs.wbs_id] = getPath(wbs.wbs_id, wbsParents, wbsArray);
  });
  return wbsFullParents;
}

export function hasParent(wbsArray, parent_id):any {
  return wbsArray.find(wbs => wbs.wbs_id === parent_id);
}

export function getPath(id, wbsParents, wbs, path = []):any {
  const parent = wbsParents[id];
  if(!hasParent(wbs, parent)) {
    return path;
  }
  path.push(parent.toString());
  return getPath(parent, wbsParents, wbs, path);
}

export function getMaxDepth(paths):any {
  return Math.max(...paths.map(path => path.length));
}



export function getAccordionFromWbsArray(wbsArray) {
  let projectWbsArrayByWbsId = {};
  console.log(JSON.stringify(wbsArray.map(r=>r.wbs_name)))
  wbsArray.forEach(wbs=>{
    projectWbsArrayByWbsId[wbs.wbs_id]=wbs;
  })
  console.log(wbsArray[0])
  let wbsAccordion = {};
  var remainingWbs = wbsArray.slice(0);

  let wbsChildren = getWbsChildren(remainingWbs);
  let wbsParents = getWbsParents(wbsArray);


  let finalWbsObj = [];

  let orderedPaths = Object.keys(wbsParents).map(wbs => [wbs.toString()].concat(wbsParents[wbs]))

  let level1 = [];
  let maxDepth = getMaxDepth(orderedPaths);

  // bottom of pyramid up
  let subsidiaryObjects = {};
  for(var depth = 0; depth < maxDepth + 1; depth++) {
    orderedPaths.forEach(path => {

      try {
        subsidiaryObjects[path[depth]] = {
          subsidiaries: wbsChildren[path[depth]]
            .map(child => subsidiaryObjects[child])
            .sort((a, b) => a.priority - b.priority),
          priority: projectWbsArrayByWbsId[path[depth]].seq_num,
          wbs_name: projectWbsArrayByWbsId[path[depth]].wbs_name,
          wbsKey: path[depth]
        }
      } catch (err) {}
    });
  }



  let final = Object.keys(subsidiaryObjects).map(key => subsidiaryObjects[key]);
  let masterWbs = wbsArray.filter(wbs=>{
    // console.log("wbs:", wbs.wbs_id)
    return !wbsArray.filter(w=>w.wbs_id!==wbs.wbs_id).find(r=>r.wbs_id===wbs.parent_wbs_id)
  });

  final = final.filter(finalWbs=>{
    return masterWbs.find(master=>master.wbs_id+""===finalWbs.wbsKey+"")
  })
  console.log("WBSWBSWBS", final)


  return final;
}








export function getWbsCode(projShortName, wbsObjects):any {
  if(!projShortName || !wbsObjects) {
    return;
  }
  const codeSegments = wbsObjects.map(wbsRow => wbsRow.wbs_short_name).reverse();
  if(codeSegments.length === 0) {
    return projShortName;
  }
  return `${projShortName}.${codeSegments.join('.')}`;
}


export function walkWbsObjects(wbsObject, projectWbsArrayByWbsId):any {
  if(!wbsObject.parent_wbs_id || !wbsObject.wbs_id || !wbsObject.wbs_short_name) {
    return [];
  }
  const parentWbsObject = projectWbsArrayByWbsId[wbsObject.parent_wbs_id];
  if(!parentWbsObject) {
    return [];
  }
  const ret = [{
    wbs_short_name: wbsObject.wbs_short_name,
    wbs_id: wbsObject.wbs_id,
    parent_wbs_id: wbsObject.parent_wbs_id,
  }, ...memoizedWalkWbsObjects(parentWbsObject, projectWbsArrayByWbsId)];
  return ret;
}

// it's possible that multiple (many?) activityTaskRows have the same wbs_id, and would therefore resolve to the same wbsObjects.
// Seems wasteful to calculate it unnecessarily, so we'll memoize it
const memoizedWalkWbsObjects = _.memoize((wbsObject, projectWbsArrayByWbsId) => {
  return walkWbsObjects(wbsObject, projectWbsArrayByWbsId);
}, wbsObject => wbsObject.wbs_id);


export function isFilterCodeSelected(filterActivityCode):any {
  return _.includes(selectedFilteringCodes, filterActivityCode);
}

export function toggleFilterCode(filterActivityCode):any {
  const filterCodeIncluded = _.includes(selectedFilteringCodes, filterActivityCode);
  if(filterCodeIncluded) {
    _.remove(selectedFilteringCodes, filterActivityCode);
  } else if(selectedFilteringCodes.length < MAX_NUM_FILTER_CODES) {
    selectedFilteringCodes.push(filterActivityCode);
  }
}

export function hasTotalFloatPermission(userId):any {
  return !!totalFloatPermissionUserIdsMap[userId] || isProjectManager(userId);
}

export function toggleTotalFloatForUser(userId):any {
  const userHasFloat = !!totalFloatPermissionUserIdsMap[userId];
  totalFloatPermissionUserIdsMap[userId] = !userHasFloat;
}

export function onChangeDataLookahead(newVal):any {
  dataLookAhead = newVal;
  recalculateActivitiesByUser();
}

export function onChangeSelectedActivityCode(selectedActivityCodeParam):any {
  filterCodeOptions = _.orderBy(activityCodesArray.filter((activityCode) => {
    return selectedActivityCodeParam && activityCode.actv_code_type_id !== selectedActivityCodeParam.actv_code_type_id;
  }), 'actv_code_type');
  selectedActivityCode = selectedActivityCodeParam;
  return { selectedActivityCode, filterCodeOptions };
}

export function onChangeSelectedActivitySubCode(newUserSubCodeSelection):any {
  userSubCodeSelection = newUserSubCodeSelection;
  recalculateActivitiesByUser();
}

export function getAllActivitiesForUser(userId):any {
  return activitiesByUser[userId] || [];
}

export function getNonCriticalActivitiesForUser(userId):any {
  return getAllActivitiesForUser(userId).filter(activity => {
    return activity.taskRow.driving_path_flag === 'N';
  });
}

export function getCriticalActivitiesForUser(userId):any {
  return getAllActivitiesForUser(userId).filter(activity => {
    return activity.taskRow.driving_path_flag === 'Y';
  });
}

export function getRenderedFilterCodes() :any{
  return _.orderBy(_.times(MAX_NUM_FILTER_CODES, i => {
    return selectedFilteringCodes[i] || undefined;
  }), 'actv_code_type');
}



export function getSubcodesForSelectedTopCode():any {
  const possibleSubCodes = (activitySubCodesArray || []).filter(subActivityCode => {
    return selectedActivityCode && subActivityCode.actv_code_type_id === selectedActivityCode.actv_code_type_id;
  });
  console.log("selectedActivityCode", selectedActivityCode,
    "activitySubCodesArray", activitySubCodesArray,
    "possibleSubCodes", possibleSubCodes,
    "userSubCodeSelection", userSubCodeSelection)
  const usedSubcodesMap = _.mapValues(_.keyBy((userSubCodeSelection || []).filter(user => {
    return user.userSelection && user.userSelection.actv_code_id;
  }), user => {
    return user.userSelection && user.userSelection.actv_code_id;
  }), obj => true);
  console.log("usedSubcodesMap", usedSubcodesMap)
  const availableSubCodes = possibleSubCodes
  console.log("availableSubCodes", availableSubCodes)
  return _.orderBy(availableSubCodes, subCode => subCode.actv_code_name);
}

export function clearUserSubCodeSelections():any {
  userSubCodeSelection.forEach(user => {
    user.userSelection = undefined;
  });
  console.log("userSubCodeSelection", userSubCodeSelection)
  return userSubCodeSelection;
}

export function isProjectManager(userId) :any{
  return project && permissions.isProjectManager(project, {
    _id: userId
  });
}

export function isProjectUpdater(userId):any {
  return project && permissions.isProjectUpdater(project, {
    _id: userId
  });
}

export function getAssignedMembers() :any{
  const assignedMembers = (userSubCodeSelection || []).filter(user => {
    return !!user.userSelection;
  });
  return _.orderBy(assignedMembers, [
    user => project && permissions.isProjectManager(project, {
      _id: user.userId
    }),
    user => user.userName,
  ], ['desc', 'asc']);
}

export function getAssignedPMs() :any{
  return getAssignedMembers().filter(user => {
    return project && permissions.isProjectManager(project, {
      _id: user.userId
    });
  });
}

export function getAssignedUpdaters():any {
  return getAssignedMembers().filter(user => {
    return project && !permissions.isProjectManager(project, {
      _id: user.userId
    });
  });
}



export function getAllDataForExport(xerData){
  allUpdateData = {};
  const xerDataArray = xerData;
  const sectionDividers = xerDataArray.reduce((arr, row, rowIndex) => {
    if(row[0] === '%T') {
      const sectionKey = row[1];
      arr.push([sectionKey, rowIndex]);
    } else if(row[0] === '%E') {
      arr.push(['END', rowIndex]);
    }
    return arr;
  }, []);

  sectionDividers.forEach((sectionData, sectionIndex) => {
    const [sectionKey, startOfSectionIndex] = sectionData;
    const nextSectionData = sectionDividers[sectionIndex + 1];
    if(!nextSectionData) {
      return;
    }
    const dataStartIndex = startOfSectionIndex + 1;
    const dataEndIndex = nextSectionData[1] - 1;

    function parseDataFromXerFromIndexToIndex() {
      return xerDataArray.slice(dataStartIndex + 1, dataEndIndex + 1).map(row => {
        const headerNamesArray = xerDataArray[dataStartIndex];
        // slice(1) on each of the two arrays because we want to ignore the %F in the 0th column
        return _.zipObject(headerNamesArray.slice(1), row.slice(1));
      });
    }

    const processedData = parseDataFromXerFromIndexToIndex();
    allUpdateData[sectionKey]=processedData;

  });

  return allUpdateData;
}



export function analyzeExcelData(xerData) {
  try {
    console.log(xerData)
    const allData = getAllDataForExport(xerData.data)

    projectArray = allData['PROJECT'];
    projectWbsArray = allData['PROJWBS'];
    projectWbsAccordion = getAccordionFromWbsArray(projectWbsArray);
    calendarArray = allData['CALENDAR'];
    taskArray = allData['TASK'];
    activityCodesArray = _.orderBy(allData['ACTVTYPE'], 'actv_code_type');
    activitySubCodesArray = allData['ACTVCODE'];
    activityTasks = allData['TASKACTV'];


    // console.log(projectWbsArray)

    xerLoaded = true;
    let badTasks = taskArray.filter(task => task.task_type === "TT_WBS" || task.task_type === "TT_LOE").map(task => task.task_id);
    taskArray = taskArray.filter(task => task.task_type != "TT_WBS" && task.task_type != "TT_LOE");
    activityTasks = activityTasks.filter(task => !badTasks.includes(task.task_id));
    return {
      xerLoaded,
      projectArray,
      projectWbsArray,
      projectWbsAccordion,
      calendarArray,
      taskArray,
      activityCodesArray,
      activitySubCodesArray,
      activityTasks
    }
  } catch (err) {
    console.error('error processing XER file: ', err);
  }
}
/*
Table - TASK
- Activity ID (task_code)
- Activity Name (task_name)
- Original Duration (target_drtn_hr_cnt)
- Start (Early Start) (early_start_date)
- Finish (Early Finish) (early_end_date)
- Total Float (total_float_hr_cnt)
- Actual Start (act_start_date)
- Actual Finish (act_end_date)
- Remaining Duration (remain_drtn_hr_cnt)
  */

export function validateUpdateForErrors(finalUpdate) {
  const errors = [];
  if(!(finalUpdate.projectId)) {
    errors.push('Missing projectId');
  }

  if(!updatePeriodName) {
    errors.push('Missing update name');
  }

  if(!finalUpdate.plannedEndDate) {
    errors.push('Missing planned end date');
  }

  if(!finalUpdate.dataLookAhead) {
    errors.push('Missing data look ahead');
  }

  if(!finalUpdate.selectedActivityCode) {
    errors.push('Missing selectedActivityCode');
  }

  const usersWithSelections = (userSubCodeSelection || []).filter(user => user.userSelection);
  if(!userSubCodeSelection || usersWithSelections.length === 0) {
    errors.push('At least 1 user must be given a subcode. If there are no non-project member users on this project, please add at least 1 in the members section.');
  }

  const usersByCode = _.groupBy(finalUpdate.usersWithSelections, user => user.userSelection && user.userSelection.actv_code_id);
  _.each(usersByCode, (users, actvCodeTypeId) => {
    if(users && users.length > 1) {
      errors.push(`Code ${actvCodeTypeId} cannot be used twice`);
    }
  });

  if(finalUpdate.selectedFilteringCodes && finalUpdate.selectedFilteringCodes.length > MAX_NUM_FILTER_CODES) {
    errors.push(`Cannot have more than ${MAX_NUM_FILTER_CODES} filter codes`);
  }

  const usedTopCodes = selectedFilteringCodes.map(filterCodeObj => filterCodeObj.actv_code_type_id);
  if(usedTopCodes.length !== _.uniq(usedTopCodes).length) {
    errors.push('Duplicate Top Codes');
  }

  if(!projectArray || projectArray.length === 0) {
    errors.push('Invalid projectArray');
  }

  // if(projectArray && projectArray.length > 1) {
  //   errors.push('Multiple projects in projectArray, using the 0th for the last_recalc_date');
  // }
  return errors;
}

/**
 * @return true if valid, false if errors present
 */
export function showErrorsIfInvalid(updateToCall) {

  const errors = validateUpdateForErrors(updateToCall);
  if(errors.length > 0) {
    console.log('Update Period failed validation');
    console.log('Please fix these errors and try again: ', errors);
    console.error('Update Period failed validation');
    console.error('Please fix these errors and try again: ', errors);
    return false;
  }
  return true;
}

export function recalculateActivitiesByUser() {
  // should this be a groupBy or keyBy?  Dunno if multiple taskArray can have the same id; we'll play it safe and assume multiple can
  const tasksByTaskId = _.groupBy(taskArray, taskRow => taskRow.task_id);

  const activityTasksByActivityCodeId = _.groupBy(activityTasks, activityTaskRow => activityTaskRow.actv_code_id);
  const activityTasksForTaskId = _.groupBy(activityTasks, tskActRow => tskActRow.task_id);

  const dataDate = getDataDate();
  if(!dataDate) {
    return;
  }
  const dataDatePlusLookAhead = moment(dataDate).startOf('day').add(parseInt(dataLookAhead, 10), 'days').toDate();

  activitiesByUser = _.mapValues(_.keyBy(userSubCodeSelection, user => user.userId), ({
    userId,
    userSelection
  }) => {
    if(!userSelection) {
      return [];
    }

    const {
      actv_code_type_id,
      actv_code_id
    } = userSelection;
    const activityTasksForThisActivityCodeId = activityTasksByActivityCodeId[actv_code_id] || [];
    const taskRows = _.flatten(activityTasksForThisActivityCodeId.filter(activityTaskRow => {
      return actv_code_type_id === activityTaskRow.actv_code_type_id;
    }).map(taskAct => {
      // theseTasks might just be 1 element, read note above; note sure if it's *only* ever 1
      // TODO are these Tasks sorted by date?
      return tasksByTaskId[taskAct.task_id].filter(taskRow => {
        if(taskRow.status_code === 'TK_Complete') {
          return false;
        } else if(taskRow.status_code === 'TK_NotStart') {
          const earlyStartDate = moment(taskRow.early_start_date).startOf('day').toDate(); // do we need the right format?
          return dataDate <= earlyStartDate && earlyStartDate <= dataDatePlusLookAhead;
        } else if(taskRow.status_code === 'TK_Active') {
          return true
        }
        return false;
      })
    }));

    const projectsByProjectId = getProjectsByProjectId();
    const projectWbsArrayByWbsId = _.keyBy(projectWbsArray, wbsObject => wbsObject.wbs_id);

    const activities = _.compact(taskRows.map(taskRow => {
      const foundCalendar = _.findLast(calendarArray, calendarRow => {
        return taskRow.clndr_id === calendarRow.clndr_id;
      });

      if(!foundCalendar) {
        throw new Error('dayHourCount not found');
      }

      // const projectRow = projectsByProjectId[taskRow.proj_id];
      const projectRow = projectsByProjectId[_.keys(projectsByProjectId)[0]];
      projShortName = (projectRow && projectRow.proj_short_name);
      // Probably a better place to do this but...

      const projectWbsRow = projectWbsArrayByWbsId[taskRow.wbs_id];

      const wbsObjects = memoizedWalkWbsObjects(projectWbsRow, projectWbsArrayByWbsId);

      const activity = {
        tskActRows: activityTasksForTaskId[taskRow.task_id],
        wbsObjects,
        wbsCode: getWbsCode(projShortName || '', wbsObjects) || '',
        taskRow,
        dayHourCount: foundCalendar.day_hr_cnt,
      };
      return activity;
    }));
    return activities;
  });
}

export function getProjectsByProjectId() {
  return _.keyBy(projectArray, project => project.proj_id);
}

export function getDataDate() {
  if(!projectArray) {
    return;
  }
  const lastRecalcDate = projectArray[0].last_recalc_date;
  return moment(lastRecalcDate).startOf('day').toDate(); // probably YYYY-MM-DD time-something?
}

export function calculateCalendarDaysFromArray(calArray) {

  let calendars = {};

  calArray.forEach(calendar => {
    let calendarData = calendar.clndr_data;
    let calendarExceptionDays = getExceptionDays(calendarData);
    let calendarWorkDays = getWorkDays(calendarData);
    calendars[calendar.clndr_id] = {
      exceptionDays: calendarExceptionDays,
      workDays: calendarWorkDays,
      dayHrs: calendar.day_hr_cnt
    };
  });
  return calendars;
}

export function addUpdate() {




  const dataDate = getDataDate();

  const projectsByProjectId = getProjectsByProjectId();

  // this is more complicated than you might think, because we have to consider the case that you can add totalFloatPermission to a user
  // and then remove that user from the update; they will still be in `totalFloatPermissionUserIdsMap` but will no longer have a userSelection
  const userIdsWithTotalFloatPermissionMap = _.keyBy(_.intersection(
    userSubCodeSelection.filter(user => user.userSelection).map(user => user.userId),
    _.keys(totalFloatPermissionUserIdsMap).filter(userId => !!totalFloatPermissionUserIdsMap[userId]),
  ), _.identity);

  const projectWbsArrayByWbsId = _.keyBy(projectWbsArray, wbsObject => wbsObject.wbs_id);
  recalculateActivitiesByUser();

  const presentWbsIdsMap = {};
  _.each(activitiesByUser, activities => {
    activities.forEach(activity => {
      presentWbsIdsMap[activity.taskRow.wbs_id] = true;
    });
  });
  console.log("selectedFilteringCodes", selectedFilteringCodes)
  const usedTopCodesMap = _.keyBy(selectedFilteringCodes.map(filterCodeObj => filterCodeObj.actv_code_type_id));
  const filteringSubCodesArray = activitySubCodesArray.filter(subCode => {
    if(selectedActivityCode.actv_code_type_id === subCode.actv_code_type_id) {
      return true;
    }
    return usedTopCodesMap[subCode.actv_code_type_id];
  });

  console.log("project", project)
  const calendars = calculateCalendarDaysFromArray(calendarArray);


  let updateToCall = {
    projectId: project._id,
    updateName: updatePeriodName,
    plannedEndDate: plannedEndDate,
    dataLookAhead: parseInt(dataLookAhead, 10),
    selectedActivityCode: selectedActivityCode,
    filteringCodesArray: selectedFilteringCodes,
    filteringSubCodesArray,
    dataDate,
    calendars,
    updatePeriodType,
    projectWbsAccordion,
    subCodesByUser: _.mapValues(_.keyBy(userSubCodeSelection, userObj => userObj.userId), userObj => userObj.userSelection && userObj.userSelection.actv_code_id),
    activitiesByUser: activitiesByUser,
    totalFloatPermissionMap: _.mapValues(userIdsWithTotalFloatPermissionMap, val => true),
    projectsByProjectId: getProjectsByProjectId(),
    projectWbsArrayByWbsId: _.pick(projectWbsArrayByWbsId, _.uniq(_.keys(presentWbsIdsMap))),
  };

  console.log("updateToCall4444", updateToCall);
  // TODO invariant(project && project._id, 'Invalid Project');
  if(!project || !project._id) {
    console.error('Please fix these errors and try again: no project');
    return { message: 'Please fix these errors and try again: no project' };
  }

  if(!showErrorsIfInvalid(updateToCall)) {
    console.log("-----------")
    let message = 'Please fix these errors and try again: ';
    validateUpdateForErrors(updateToCall).forEach(fail => {
      message += fail + ", ";
    });
    message = message.substring(0, message.length - 2);
    return { message };
  }





  console.log(updateToCall);
  return updateToCall;
}


let updatePeriodName, plannedEndDate, dataLookAhead;
var selectedActivityCode;

export function analyzeExcelDataTest(selectedCode) {
  selectedActivityCode = selectedCode;

  onChangeSelectedActivityCode(selectedActivityCode)
  console.log("filterCodeOptionsfilterCodeOptions", filterCodeOptions)
  console.log("selectedActivityCodeselectedActivityCode", selectedActivityCode)
  clearUserSubCodeSelections();
  activitySubCodesArray = getSubcodesForSelectedTopCode();
  toggleFilterCode(filterCodeOptions[0])
  toggleFilterCode(filterCodeOptions[1])
  toggleFilterCode(filterCodeOptions[2])
  toggleFilterCode(filterCodeOptions[3])
  onChangeSelectedActivitySubCode(activitySubCodesArray[0])
  console.log("00000000", activitySubCodesArray)
  // onChangeSelectedActivitySubCode(activitySubCodesArray.find(code=>code.actv_code_id==9269), userSubCodeSelection[0])


  recalculateActivitiesByUser();
  return addUpdate()
}

export function setProject(fullProject) {
  project = fullProject;
}
export function setUserSubCodeSelection(codes) {
  userSubCodeSelection = codes;
}
export function setProjectMembers(fullProjectMembers) {
  projectMembers = fullProjectMembers;
}
export function setUpdatePeriodName(updateName) {
  updatePeriodName = updateName;
}
export function setUpdatePeriodType(incomingUpdatePeriodType) {
  updatePeriodType = incomingUpdatePeriodType;
}
export function setDataLookAhead(days) {
  dataLookAhead = days;
}
export function setPlannedEndDate(date) {
  plannedEndDate = date
}




export function setUpdate(fullProject, fullProjectMembers, incomingUpdatePeriodType) {
  project = fullProject;
  projectMembers = fullProjectMembers;
  selectedActivityCode = {
    "actv_code_type_id": 719,
    "actv_short_len": 7,
    "seq_num": 16474,
    "actv_code_type": "5-DETAREA",
    "proj_id": 797,
    "wbs_id": "",
    "actv_code_type_scope": "AS_Project"
  }

  userSubCodeSelection = projectMembers.map(user => {
    return {
      userId: user._id,
      userName: user.profile.name,
      userSelection: undefined,
    };
  });


  updatePeriodName = "updateName";
  updatePeriodType = incomingUpdatePeriodType;
  plannedEndDate = new Date()
  dataLookAhead = 90;



}



// WEBPACK FOOTER //
// ./src/services/xer.ts